import React from 'react'

const Footer = () => {
  return (
  <footer className='bg-primary py-12'>
<div className='container mx-auto'>
<p className='text-white text-center'>Copyright &copy; Fashion Shop 2023. Todos os direitos reservados.
</p>

</div>
  </footer>
  );
};
  
  

export default Footer;
